// extracted by mini-css-extract-plugin
export default {"taskSelected":"Admin_taskSelected__zikwu","taskNotSelected":"Admin_taskNotSelected__i+KUA"};